import { Component, OnInit } from '@angular/core';
import { ReportsService } from '../services/reports.service';
import { CSVService } from '../services/csv.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-host-stats-report',
  templateUrl: './host-stats-report.component.html',
  styleUrls: ['./host-stats-report.component.css']
})
export class HostStatsReportComponent implements OnInit {

  constructor(private reportService: ReportsService, private downloadService: CSVService) { }

  statsObject: HostStats[] | null;
  loading = true;
  err = "";

  ngOnInit(): void {
    this.reportService.getHostStatsReport()
      .pipe(finalize(() => this.loading = false))
      .subscribe(
        (res: HostStats[] | null) => this.statsObject = res,
        err => this.err = err.error.detail
      )
  }

  downloadStats() {
    if (!this.statsObject) return;
    let csv = "Name,City,State,Games Run,Venues Hosted,First Game On,Last Game On,Hosting Duration";
    for (let hs of this.statsObject) {
      let firstGame = hs.first_hosted_on ? hs.first_hosted_on.slice(0, 10) : '';
      let lastGame = hs.last_hosted_on ? hs.last_hosted_on.slice(0, 10) : '';
      let daysSinceFirstGame = hs.first_hosted_on ? Math.floor((new Date().getTime() - new Date(hs.first_hosted_on).getTime()) / (1000 * 60 * 60 * 24)) : 0;
      let yearsSinceFirstGame = hs.first_hosted_on ? Math.floor(daysSinceFirstGame / 365) : 0;
      let remainDays = hs.first_hosted_on ? daysSinceFirstGame % 365 : 0;
      let remainMonths = hs.first_hosted_on ? Math.floor(remainDays / 30.417) : 0;
      let remainWeeks = hs.first_hosted_on ? Math.floor((remainDays % 30.417) / 7) : 0;
      let friendlySince = yearsSinceFirstGame > 0 ? `${yearsSinceFirstGame} year${yearsSinceFirstGame > 1 ? 's' : ''}` : "";
      friendlySince = remainMonths ? `${friendlySince}${remainWeeks ? '' : ' and'} ${remainMonths} month${remainMonths > 1 ? 's' : ''}` : friendlySince;
      friendlySince = remainWeeks ? `${friendlySince} and ${remainWeeks} week${remainWeeks > 1 ? 's' : ''}` : friendlySince;
      csv = `${csv}\n${hs.name},${hs.city},${hs.state},${hs.total_games},${hs.venues_hosted_at},`;
      csv = `${csv}${hs.first_hosted_on ? hs.first_hosted_on.slice(0, 10) : ''},${hs.last_hosted_on ? hs.last_hosted_on.slice(0, 10) : ''},${friendlySince}`;
    }
    const now = new Date();
    this.downloadService.export(csv, `Host Stats as of ${now.getMonth()}/${now.getDate()}/${now.getFullYear()}`)
  }

}
